import axios from 'axios'; // Or whatever HTTP client/base instance you use in your project

export const leaveApprovalService = {
  /**
   * Checks if a specific user has permission to approve/manage a given leave request.
   * @param {Object} params
   * @param {string|number} params.userId - The ID of the currently logged-in user.
   * @param {string|number} params.leaveRequestId - The ID of the leave request.
   * @returns {Promise<boolean|Object>} Returns the boolean or response object from your backend.
   */
  checkApprover: async ({ userId, leaveRequestId }) => {
    // Uses path parameter for leaveRequestId and query parameter for userId
    const response = await axios.get(`/leave/${leaveRequestId}/can-approve`, {
      params: { userId }
    });
    return response;
  },
};